import React, { useEffect, useState } from 'react';

/** Small pill shown next to a substitution section header when we auto-picked
 *  a replacement for an ingredient removed due to allergies. Fades in a
 *  couple seconds after mount rather than popping in immediately, so it
 *  reads as a deliberate reveal rather than layout noise. Uses inline
 *  style + setTimeout (not a CSS keyframe) because this component is shared
 *  with MealPlanViewer.js, which doesn't load the storefront's CSS files. */
const SubstitutionBadge = ({ removedName, addedName, delayMs = 200 }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setVisible(true), delayMs);
        return () => clearTimeout(timer);
    }, [delayMs]);

    return (
        <span
            title={`${removedName} was removed for your allergies — we picked ${addedName} instead`}
            style={{
                display: 'inline-block',
                marginLeft: '8px',
                fontSize: '11px',
                fontWeight: '600',
                backgroundColor: '#e3f2fd',
                color: '#1976d2',
                padding: '2px 7px',
                borderRadius: '10px',
                opacity: visible ? 1 : 0,
                transition: 'opacity 0.4s ease',
            }}
        >
            ↻ Swapped in {addedName} for {removedName}
        </span>
    );
};

export default SubstitutionBadge;
